import { render } from "./SupportUs.vue?vue&type=template&id=6ae3bf26"
import script from "./SupportUs.vue?vue&type=script&lang=js"
export * from "./SupportUs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__